jQuery(function ($) {
  // Fade header background in as you scroll
  const fadeDistance = 200;
  function updateNavOpacity() {
    const top = $(window).scrollTop();
    $('.header--fade').css('background', `rgba(0, 51, 160, ${top / fadeDistance})`);
  }

  updateNavOpacity();
  $(window).on('scroll', updateNavOpacity);

  function updateVhCustomProp() {
    // Set CSS custom property to overcome issues with viewport units on mobile
    // Credit: https://css-tricks.com/the-trick-to-viewport-units-on-mobile
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
  updateVhCustomProp();

  let resizeTimer;
  $(window).on('resize', () => {
    updateVhCustomProp();

    // Disable CSS transitions during screen resize
    $('.notransition-onresize').addClass('notransition');
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {
      $('.notransition-onresize').removeClass('notransition');
    }, 100);
  });

  // Enable CSS transition after initial page load
  setTimeout(() => {
    $('.page-container').removeClass('notransition');
  }, 100);

  // Keep scroll padding in sync with top nav height
  const ro = new ResizeObserver(() => {
    const $mainContent = $('.main-content');
    if ($mainContent.length) {
      let scrollPadding = $mainContent[0].getBoundingClientRect().top + window.scrollY;

      const $localTasks = $('.subnav--local-tasks');
      if ($localTasks.is(':visible')) {
        scrollPadding -= $localTasks.height();
      }

      const $jumpNav = $('.subnav--jump');
      if ($jumpNav.length) {
        scrollPadding += $jumpNav.outerHeight();
      }

      document.documentElement.style.scrollPaddingTop = `${scrollPadding}px`;
    }
  });

  ro.observe($('body')[0]);

  if ($('.top-nav').length) {
    ro.observe($('.top-nav')[0]);
  }

  // Hides administrative notes on page.
  $('.field-administrative-notes').each(function () {
    $(this).on('click', function () {
      $(this).addClass('visually-hidden');
    });
  });

  // Achieves last child of type for a specific class.
  // Adds border bottom for last dropdown of page sections on mobile.
  $('.node-components .ukhc-section').last().addClass('ukhc-section--last');

  // Sets facebook icon to FacebookÃ¢ÂÂs url scheme based on user agent.
  const ua = navigator.userAgent;
  const a = document.getElementById('footer-facebook');
  if (/android/i.test(ua)) {
    a.setAttribute('href', 'fb://page/63992477570');
  } else if (/iPad|iPhone|iPod/.test(ua)) {
    a.setAttribute('href', 'fb://profile/63992477570');
  }
});
